// UX-1 — client-side image compression (canvas based, no extra dependency).
// Shrinks camera photos below the server's 500 KB evidence cap before upload.
// The BACKEND remains the real gate (magic bytes + size + EXIF strip).

const MAX_BYTES = 500 * 1024;

async function toBlob(canvas, quality) {
  return new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
}

function drawScaled(source, maxDim) {
  const scale = Math.min(1, maxDim / Math.max(source.width, source.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(source.width * scale));
  canvas.height = Math.max(1, Math.round(source.height * scale));
  canvas.getContext("2d").drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas;
}

export async function compressImage(file, maxBytes = MAX_BYTES) {
  if (!file || !/^image\//.test(file.type || "")) return file;
  if (file.size <= maxBytes) return file;
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return file; // undecodable here — the server will validate and reject
  }
  let maxDim = 1600;
  for (let pass = 0; pass < 3; pass++) {
    const canvas = drawScaled(bitmap, maxDim);
    let quality = 0.85;
    for (let i = 0; i < 5; i++) {
      const blob = await toBlob(canvas, quality);
      if (blob && blob.size <= maxBytes) {
        const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
        return new File([blob], name, { type: "image/jpeg" });
      }
      quality -= 0.15;
    }
    maxDim = Math.round(maxDim * 0.6);
  }
  return file; // give up — server enforces the cap with a clear error
}
